<!-- <svg
  xmlns="http://www.w3.org/2000/svg"
  height="48px"
  viewBox="0 0 24 24"
  width="48px"
  fill="#000000"
>
  <path d="M0 0h24v24H0V0z" fill="none" />
  <path d="M7 10l5 5 5-5H7z" />
</svg> -->

<svg
  xmlns="http://www.w3.org/2000/svg"
  height="32px"
  viewBox="0 0 24 24"
  width="32px"
  fill="#9c9c9c"
>
  <path d="M0 0h24v24H0V0z" fill="none" />
  <path d="M7 10l5 5 5-5H7z" />
</svg>
